/* eslint-disable */

export enum CheckoutDeliveryCarriageMethod {
	NOTSET = 0,
	HOME = 1,
	PICKUP = 2,
	SPECIAL = 3,
	SPECIALHOME = 4,
	SPECIALOUT = 5,
	HOMEDELIVERYALTERNATIVE = 6,
	OUTDELIVERYALTERNATIVE = 7,
	
}
